<template>
	<v-card elevation="0" max-width="1200px">
		<v-card elevation="0" class="pa-6 pb-4">
			<v-row dense>
				<v-col cols="12" md="7">
					<v-card outlined>
						<v-row class="px-2">
							<v-col cols="12" md="5">
								<v-text-field
									v-model="form.nombre"
									label="Nombre"
									required
									prepend-icon="mdi-account"
									:disabled="formType == 'open'"
									:error-messages="nombreErrores"
									@blur="$v.form.nombre.$touch()"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="7">
								<v-text-field
									v-model="form.apellidos"
									label="Apellidos"
									required
									:disabled="formType == 'open'"
									:error-messages="apellidoErrores"
									@blur="$v.form.apellidos.$touch()"
								></v-text-field>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
				<v-col cols="12" md="5">
					<v-card outlined>
						<v-row class="px-2">
							<v-col cols="12" md="5">
								<v-select
									v-model="form.tipoDocumento"
									:items="documentoTipo"
									label="Tipo"
									required
									clearable
									:disabled="formType == 'open'"
									single-line
									prepend-icon="mdi-card-account-details"
									:error-messages="tipoDocumentoErrores"
								>
								</v-select>
							</v-col>
							<v-col cols="12" md="7">
								<v-text-field
									v-model="form.documento"
									:disabled="formType == 'open'"
									:error-messages="documentoErrores"
									:label="
										form.tipoDocumento
											? form.tipoDocumento
											: 'Documento'
									"
									required
									@blur="$v.form.documento.$touch()"
								></v-text-field>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>

			<v-row dense>
				<v-col cols="12" md="3">
					<v-card class="px-2" outlined>
						<v-text-field
							v-model="form.email"
							:error-messages="emailErrores"
							prepend-icon="mdi-email"
							label="E-mail"
							required
							:disabled="formType == 'open'"
							@blur="$v.form.email.$touch()"
						>
						</v-text-field>
					</v-card>
				</v-col>
				<v-col cols="12" md="9">
					<v-card flat outlined class="px-2">
						<v-row>
							<v-col cols="12" md="7">
								<v-text-field
									v-model="form.direccion"
									label="Dirección"
									prepend-icon="mdi-map-marker"
									required
									:disabled="formType == 'open'"
									@blur="$v.form.direccion.$touch()"
									:error-messages="direccionErrores"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="2">
								<v-text-field
									v-model="form.cp"
									label="CP"
									required
									:disabled="formType == 'open'"
									:error-messages="cpErrores"
									prepend-icon="mdi-post"
									@blur="$v.form.cp.$touch()"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="3">
								<v-text-field
									v-model="form.localidad"
									label="Localidad"
									required
									:disabled="formType == 'open'"
									:error-messages="localidadErrores"
									@blur="$v.form.localidad.$touch()"
									prepend-icon="mdi-city"
								></v-text-field>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>


			<v-row dense>
				<v-col cols="12" md="3">
					<v-card class="px-2" outlined>
						<v-text-field
							v-model="form.nuss"
							:error-messages="NUSSErrores"
							prepend-icon="mdi-card-account-details"
							label="NUSS"
							:disabled="formType == 'open'"
							@blur="$v.form.nuss.$touch()"
						>
						</v-text-field>
					</v-card>
				</v-col>
				<v-col cols="12" md="5">
					<v-card flat outlined class="px-2">
						<v-text-field
							v-model="form.iban"
							label="IBAN"
							prepend-icon="mdi-bank"
							:disabled="formType == 'open'"
							@blur="$v.form.iban.$touch()"
							:error-messages="IBANErrores"
						></v-text-field>
					</v-card>
				</v-col>
				<v-col cols="12" md="4">
					<v-card
						flat
						outlined
						fill-height
						class="px-2"
						style="height: 100%"
					>
						<v-row no-gutters>
							<v-col align-self="center">
								<v-text-field
									v-model="telefono"
									label="Móvil"
									prepend-icon="mdi-cellphone"
									append-icon="mdi-plus-circle-outline"
									@keyup.enter="addTelefono"
									@click:append="addTelefono"
									:error-messages="telefonoErrores"
									:disabled="formType == 'open'"
									type="number"
									counter="9"
								>
									<!-- @blur="$v.form.telefono.$touch()" -->
								</v-text-field>
								<v-chip
									:disabled="formType == 'open'"
									v-for="(
										curr_telf, index
									) in form.numerosContacto"
									:key="index"
									close
									@click:close="removeTelefono(curr_telf)"
									class="ma-1 d-flex justify-center"
								>
									{{ curr_telf }}
								</v-chip>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>


			<v-row dense>
				<v-col cols="12" :md="opcionesCuenta ? 3 : 12">
					<v-card class="px-2" style="padding-bottom: 11px;" outlined>
						<v-text-field
							v-model="form.costoGeneral"
							:error-messages="costoGeneralErrores"
							prepend-icon="mdi-account-cash"
							label="Costo general"
							hint="Costo que supone el comercial a la empresa, para calcular su rentabilidad"
							:disabled="formType == 'open'"
							@blur="$v.form.email.$touch()"
						>
						</v-text-field>
					</v-card>
				</v-col>
				<v-col cols="12" md="2" v-if="opcionesCuenta">
					<v-card flat outlined class="px-2" style="padding-bottom: 11px;">
						<v-select
							:items="opcionesCuenta.talla"
							item-text="human"
							item-value="encoded"
							label="Talla"
							clearable
							prepend-icon="mdi-tshirt-crew"
							v-model="form.talla"
							:disabled="formType == 'open'"
							@blur="$v.form.rol.$touch()"
							:error-messages="rolErrores"
						>
						</v-select>
					</v-card>
				</v-col>
				<v-col cols="12" :md="opcionesCuenta ? 7 : 12">
					<v-card flat outlined class="px-2">
						<v-select
							item-text="human"
							item-value="encoded"
							:items="weekdayChoices"
							label="Días laborables"
							multiple
							v-model="form.laborableWeekdays"
							clearable
							chips
						>
						</v-select>
					</v-card>
				</v-col>
			</v-row>


			<div v-if="formType == 'edit'">
				<v-row dense>
					<v-col cols="12" md="5">
						<v-card class="px-2" outlined>
							<v-text-field
								readonly
								v-model="form.password"
								:error-messages="passwordErrores"
								:append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
								:type="show1 ? 'text' : 'password'"
								label="Nueva contraseña"
								hint="Al menos 6 caracteres de longitud"
								counter
								@click:append="show1 = !show1"
								@blur="$v.form.password.$touch()"
							>
							</v-text-field>
						</v-card>
					</v-col>
					<v-col cols="12" md="5">
						<v-card flat outlined class="px-2">
							<v-text-field
								v-model="form.password2"
								readonly
								:error-messages="password2Errores"
								:append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
								:type="show2 ? 'text' : 'password'"
								label="Confirma contraseña"
								hint="Al menos 6 caracteres de longitud"
								@click:append="show2 = !show2"
								counter
								@blur="$v.form.password2.$touch()"
							>
							</v-text-field>
						</v-card>
					</v-col>
					<v-col cols="12" md="2">
						<v-card flat outlined class="d-flex justify-center">
							<v-checkbox
								v-model="isRandom"
								label="Aleatoria"
								@change="randomPassword()"
							>
							</v-checkbox>
						</v-card>
					</v-col>
				</v-row>
			</div>

			<v-row dense>
				<v-col cols="12">
					<v-card flat outlined class="pa-2">
						<v-row>
							<v-col cols="12" :md="opcionesCuenta ? 4 : 6">
								<v-select
									prepend-icon="mdi-bookmark"
									:items="rolTipo"
									label="Rol"
									v-model="rol"
									:disabled="formType == 'open'"
									@blur="$v.form.rol.$touch()"
									:error-messages="rolErrores"
								>
								</v-select>
							</v-col>
							<v-col cols="12" md="4" v-if="opcionesCuenta">
								<v-select
									prepend-icon="mdi-form-select"
									:items="opcionesCuenta.tipoComercial"
									item-text="human"
									item-value="encoded"
									label="Tipo comercial"
									v-model="form.tipoComercial"
									:disabled="formType == 'open'"
									@blur="$v.form.tipoComercial.$touch()"
									:error-messages="tipoComercialErrores"
								>
								</v-select>
							</v-col>
							<v-col cols="12" :md="opcionesCuenta ? 4 : 6">
								<v-select
									prepend-icon="mdi-list-status"
									:items="[
										{
											'encoded': 'ALTA',
											'human': 'Alta'
										},
										{
											'encoded': 'BAJA',
											'human': 'Baja'
										},
										{
											'encoded': 'INACTIVO',
											'human': 'Inactivo'
										},
										{
											'encoded': 'VACACIONES',
											'human': 'Vacaciones'
										}
									]"
									item-text="human"
									item-value="encoded"
									label="Estado"
									:disabled="formType == 'open'"
									@blur="$v.form.estado.$touch()"
									v-model="estado"
									:error-messages="estadoErrores"
								>
								</v-select>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="3">
								<v-text-field
									prepend-icon="mdi-form-textbox"
									v-model="form.username"
									label="Nombre de usuario"
									required
									@blur="$v.form.username.$touch()"
									:error-messages="usernameErrores"
									:disabled="
										inferirUsername || formType == 'open'"
								>
								</v-text-field>
							</v-col>
							<v-col
								cols="12"
								md="4"
								class="mb-4 d-flex justify-center"
							>
								<v-switch
									v-model="inferirUsername"
									hide-details
									:disabled="formType == 'open'"
									label="Inferir nombre de usuario"
								></v-switch>
							</v-col>
							<v-col
								cols="12"
								md="2"
								class="mb-4 d-flex justify-center"
							>
								<v-select
									v-model="form.maxHolidays"
									:items="Array.from(Array(40).keys())"
									label="Vacaciones"
									:disabled="formType == 'open'"
								>
								</v-select>
							</v-col>
							<v-col
								cols="12"
								md="3"
								class="mb-4 d-flex justify-center"
							>
								<v-select
									v-model="form.holidaysType"
									item-text="human"
									item-value="encoded"
									:items="opcionesCuenta.accountHolidaysType"
									label="Tipo de vacaciones"
									:disabled="formType == 'open'"
								>
								</v-select>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>

			<v-row justify="end" dense class="py-2">
				<v-col cols="12" md="4" class="ml-auto">
					<div
						:class="
							$vuetify.breakpoint.smAndDown
								? 'd-block'
								: 'd-flex justify-end'
						"
					>
						<v-btn
							v-if="formType != 'open' && formType != ''"
							depressed
							:width="$vuetify.breakpoint.smAndDown ? '100%' : ''"
							:class="
								$vuetify.breakpoint.smAndDown ? 'mb-1' : 'mr-2'
							"
							color="indigo"
							dark
							@click="submit"
						>
							<v-icon left> mdi-content-save </v-icon>
							guardar
						</v-btn>
						<!-- <v-btn
							depressed
							text
							color="red"
							:width="$vuetify.breakpoint.smAndDown ? '100%' : ''"
							:class="$vuetify.breakpoint.smAndDown ? 'mb-2' : ''"
							@click="close"
						>
							cerrar
						</v-btn> -->
					</div>
				</v-col>
			</v-row>
			<v-progress-linear
				:indeterminate="true"
				:active="isSaving"
			></v-progress-linear>
		</v-card>
	</v-card>
</template>
<script>
import { documentoTipo } from '@/util/optionsTtForm.json';
import {
	required,
	maxLength,
	minLength,
	email,
	requiredIf,
	sameAs,
} from 'vuelidate/lib/validators';
import { mapGetters, mapState } from 'vuex';
import {
	nombreErrores,
	apellidoErrores,
	tipoDocumentoErrores,
	documentoErrores,
	localidadErrores,
	direccionErrores,
	cpErrores,
	emailErrores,
	passwordErrores,
	password2Errores,
	usernameErrores,
	rolErrores,
	NUSSErrores,
	costoGeneralErrores,
	IBANErrores,
	tipoComercialErrores,
	estadoErrores,
	telefonoErrores,
} from '../AccountsTable/errorHandlers';
// let rolTipo = Object.keys(this.$store.state.general.rolesEncode)
export default {
	name: 'ComercialesTableFilterDialog',
	data: () => ({
		show1: false,
		show2: false,
		isRandom: false,
		telefono: '',
		bools: {
			menu_fecha: false,
		},
		documentoTipo: documentoTipo,
		inferirUsername: false,
	}),
	validations() {
		let regexTelefono = /^(6|7|8|9)([0-9]){8}$/;
		let validTelefono = () => {
			return this.telefono.length > 0
				? regexTelefono.test(this.telefono)
				: true;
			// console.log('$v')
			// console.log(this.$v)
		};

		let identifier = () => {
			if (this.form.numerosContacto && this.form.numerosContacto.length) {
				return true;
			}
			return false;
		};

		let form = {
			nombre: {
				required,
				// max: maxLength(25)
			},
			apellidos: {
				required,
				// max: maxLength(30)
			},
			tipoDocumento: {
				// required,
			},
			documento: {},
			localidad: {},
			direccion: {},
			cp: {
				min: minLength(5),
				max: maxLength(5),
			},
			numerosContacto: {
				// identifier,
			},
			nuss: {
				min: minLength(12),
				max: maxLength(12),
			},
			iban: {
				min: minLength(24),
				max: maxLength(24),
			},
			tipoComercial: {
				requiredIf: requiredIf(() => {
					return (
						(this.form.rol &&
							this.form.rol.id ==
								this.$store.state.general.rolesEncode
									.Comercial) ||
						this.form.rol.id ==
							this.$store.state.general.rolesEncode.Manager
					);
				}),
			},
			costoGeneral: {},
			email: {
				required,
				email,
			},
			password: {
				min: minLength(6),
				max: maxLength(18),
			},
			password2: {
				requiredIf: requiredIf(() => {
					return this.form.password;
				}),
				sameAs: sameAs(() => {
					return this.form.password;
				}),
			},
			estado: {
				required,
			},
			username: {
				required,
			},
			rol: {
				required,
			},
		};

		const telefono = {
			validTelefono,
			max: maxLength(9),
			min: minLength(9),
		};
		return {
			form,
			telefono,
			validationGroup: ['form', 'telefono'],
		};
	},
	computed: {
		nombreErrores,
		apellidoErrores,
		tipoDocumentoErrores,
		documentoErrores,
		localidadErrores,
		direccionErrores,
		cpErrores,
		emailErrores,
		passwordErrores,
		password2Errores,
		NUSSErrores,
		usernameErrores,
		rolErrores,
		tipoComercialErrores,
		costoGeneralErrores,
		IBANErrores,
		estadoErrores,
		telefonoErrores,
		dialogState: {
			get: function () {
				let state = false;
				switch (this.formType) {
					case 'create':
						state =
							this.$store.state.rrhh.nuevaCuentaDialogo.isOpen;
						break;
					case 'edit':
						state =
							this.$store.state.rrhh.editarCuentaDialogo.isOpen;
						break;
					case 'open':
						state = this.$store.state.rrhh.viewCuentaDialogo.isOpen;
					default:
						break;
				}
				return state;
			},
			set: function () {
				switch (this.formType) {
					case 'create':
						this.$store.dispatch('rrhh/closeNuevaCuentaDialogo');
						break;
					case 'edit':
						this.$store.dispatch('rrhh/closeEditarCuentaDialogo');
						break;
					case 'open':
						this.$store.dispatch('rrhh/closeCuentaDialogo');
					default:
						break;
				}
			},
		},
		fecha: {
			get: function () {
				// console.log(this.form.fecha_venta)
				if (!this.form.fecha.length) return;
				const [year, month, day] = this.form.fecha[0].split('-');
				if (!this.form.fecha[1]) return `${day}/${month}/${year}`;
				const [year2, month2, day2] = this.form.fecha[1].split('-');
				return (
					`${day}/${month}/${year}` +
					' ~ ' +
					`${day2}/${month2}/${year2}`
				); // return ''
			},
			set: function (val) {
				if (!val) {
					val = [];
				}
				this.form.fecha = val;
			},
		},
		email: function () {
			return this.form.email;
		},
		estado: {
			get() {
				return this.form.estado ? this.form.estado : '';
			},
			set(val) {
				this.form.estado = val;
			},
		},
		rol: {
			get() {
				return this.form.rol
					? this.$store.state.general.rolesDecode[this.form.rol.id]
					: '';
			},
			set(val) {
				this.form.rol = {
					id: this.$store.state.general.rolesEncode[val],
				};
			},
		},
		formType() {
			// "create" si es formulario para crear cuenta o "edit" si es para editar
			let type = '';
			if (this.$store.state.rrhh.nuevaCuentaDialogo.isOpen)
				type = 'create';
			if (this.$store.state.rrhh.editarCuentaDialogo.isOpen)
				type = 'edit';
			if (this.$store.state.rrhh.viewCuentaDialogo.isOpen) type = 'open';

			return type;
		},
		form: {
			get() {
				let form = {};
				switch (this.formType) {
					case 'create':
						form = this.$store.state.rrhh.nuevaCuentaDialogo.form;
						break;
					case 'edit':
						form = this.$store.state.rrhh.editarCuentaDialogo.form;
						break;
					case 'open':
						form = this.$store.state.rrhh.viewCuentaDialogo.form;
						break;
					default:
						break;
				}
				return form;
			},
			set() {},
		},
		isSaving() {
			let isSaving = false;
			switch (this.formType) {
				case 'create':
					isSaving =
						this.$store.state.rrhh.nuevaCuentaDialogo.isSaving;
					break;
				case 'edit':
					isSaving =
						this.$store.state.rrhh.editarCuentaDialogo.isSaving;
					break;
				default:
					break;
			}
			return isSaving;
		},
		tenantInfo() {
			return JSON.parse(localStorage.getItem('tenantInfo'));
		},
		opcionesCuenta() {
			return JSON.parse(localStorage.getItem('opciones'))?.cuenta;
		},
		...mapState('general', {
			rolTipo: (state) => Object.keys(state.rolesEncode),
		}),
		// ...mapState('util', {
		//     opcionesCuenta: (state) => state.opciones.cuenta,
		// }),
		...mapGetters('login', {
			hasSuperAdminPermission: 'hasSuperAdminPermission',
		}),
		weekdayChoices() {
			return [
				{ encoded: 0, human: 'Lunes' },
				{ encoded: 1, human: 'Martes' },
				{ encoded: 2, human: 'Miércoles' },
				{ encoded: 3, human: 'Jueves' },
				{ encoded: 4, human: 'Viernes' },
				{ encoded: 5, human: 'Sábado' },
				{ encoded: 6, human: 'Domingo' },
			];
		},
	},
	created() {
		if (!this.hasSuperAdminPermission) {
			let index = this.rolTipo.indexOf('SuperAdmin');
			if (index > -1) {
				this.rolTipo.splice(index, 1);
			}
		}
	},
	methods: {
		random_password(length) {
			let letters =
				'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
			let passwd = '';
			for (var i = 0; i < length; i++) {
				passwd += letters.charAt(
					Math.floor(Math.random() * letters.length)
				);
			}
			return passwd;
		},
		randomPassword() {
			if (this.isRandom) {
				this.form.password = this.form.password2 =
					this.random_password(16);
			} else {
				this.form.password = this.form.password2 = '';
			}
		},
		addTelefono() {
			if (!this.form.numerosContacto) {
				this.form.numerosContacto = [];
			}

			if (this.form.numerosContacto.includes(this.telefono)) {
				this.$store.dispatch('util/showStatusSnackBar', {
					// Mostrar la barrita de error arriba
					statusType: 'error',
					message: 'Teléfono ya añadido',
				});
				return;
			}

			this.$v.telefono.$touch();
			if (this.$v.telefono.$invalid) {
				return;
			}
			if (this.telefono === '') {
				return;
			}
			this.form.numerosContacto.push(this.telefono);
			this.$v.telefono.$reset();
			this.telefono = '';
		},
		removeTelefono(telefono) {
			this.form.numerosContacto.splice(
				this.form.numerosContacto.indexOf(telefono),
				1
			);
		},
		submit() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				this.$store.dispatch('util/showStatusSnackBar', {
					statusType: 'error',
					message: 'Hay un error en los campos',
				});
			} else {
				console.log('submit!');
				this.$v.$reset();
				switch (this.formType) {
					case 'create':
						this.$store.dispatch('rrhh/crearCuenta').then(() => {
							this.close();
						});
						break;
					case 'edit':
						this.$store.dispatch('rrhh/editarCuenta').then(() => {
							this.close();
						});
						break;
					default:
						break;
				}
			}
		},
		close() {
			switch (this.formType) {
				case 'create':
					this.$store.dispatch('rrhh/closeNuevaCuentaDialogo');
					break;
				case 'edit':
					this.$store.dispatch('rrhh/closeEditarCuentaDialogo');
					break;
				default:
					this.dialogState = false;
					break;
			}
		},
	},
	watch: {
		email() {
			if (this.inferirUsername && this.form.email) {
				this.form.username = this.form.email.split('@')[0];
			}
		},
		inferirUsername: {
			handler(val) {
				if (val && this.form.email) {
					this.form.username = this.form.email.split('@')[0];
				}
			},
			immediate: true,
		},
		form: {
			// Este solo comprueba que cambie la referencia del form, como señal
			// de que se ha cerrado o abierto otro y podemos borrar el campo telefono
			// (del campo de añadir telefono)
			deep: false,
			immediate: true,
			handler: function () {
				this.telefono = '';
			},
		},
	},
};
</script>